import api from "PFCore/api";
import { Collection } from "PFCore/types";
import { KPI } from "PFCore/types/kpi";

export type KPIIndicatorsResponse = Collection<KPI[]>;

export const fetchKPIIndicators = async (): Promise<KPIIndicatorsResponse> =>
  api<KPIIndicatorsResponse>({ url: "kpi_indicators" });
